module.exports = __webpack_public_path__ + "media/images/home/edueeno-586c91bc4f534395a1f6fce58b721a39.svg";